import styled from 'styled-components'

export const ImageContainer = styled.div`
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`
